import React from 'react';

import { Dashboard as DashboardComponent } from '../components/organisation/dashboard';
import { usePageContext } from 'src/context/page.context';
import { useTranslation } from 'react-i18next';
import { useAuthContext } from 'src/context/auth.context';

export const Dashboard = () => {
  const { t } = useTranslation();
  const { user } = useAuthContext();
  const { setHeader, setBreadcrumbs } = usePageContext();

  setHeader(t('my-organisation.title'));
  setBreadcrumbs(undefined);

  if (!user) {
    return null;
  }

  return <DashboardComponent />;
};

export default Dashboard;
